<template>
  <base-section
    id="pro-features"
  >
    <v-img
      :src="require('@/assets/logo-flag.svg')"
      class="mx-auto mb-8"
      max-width="250"
    />

    <base-section-heading title="Flag 특장점">
      선/후 작업자간 구두로 지시하고 전달되던 Know-How가 전용 어플리케이션을 통해 자동으로 연결됩니다.<br>전용 어플리케이션과 NFC Tag를 사용하여 기존 현장 점검자의 업무를 획기적으로 줄이고,<br>건물주에게 전문화된 관리 서비스로 업그레이드 해드립니다.
    </base-section-heading>

    <v-container>
      <v-row>
        <v-col cols="12">
          <v-img
            :src="require('@/assets/diagram-1.svg')"
            class="mx-auto mb-8"
            max-width="1000"
          />
        </v-col>
      </v-row>
      <!-- <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          md="7"
        >
          <v-simple-table>
            <thead>
              <tr>
                <th />
                <th class="body-1 font-weight-bold text-center">
                  What's in the Demo?
                </th>
                <th class="body-1 font-weight-bold text-center">
                  What's in the PRO version?
                </th>
              </tr>
            </thead>

            <tbody class="body-1">
              <tr
                v-for="([name, one, two], i) in features"
                :key="i"
              >
                <td v-text="name" />

                <td class="text-center font-weight-bold">
                  <template v-if="typeof one === 'boolean'">
                    <v-icon :color="one ? 'success' : 'error'">
                      mdi-{{ one ? 'check' : 'close' }}
                    </v-icon>
                  </template>

                  <template v-else>
                    {{ one }}
                  </template>
                </td>

                <td class="text-center font-weight-bold">
                  <template v-if="typeof two === 'boolean'">
                    <v-icon :color="two ? 'success' : 'error'">
                      mdi-{{ two ? 'check' : 'close' }}
                    </v-icon>
                  </template>

                  <template v-else>
                    {{ two }}
                  </template>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>

        <v-col
          cols="12"
          md="5"
        >
          <v-card
            elevation="16"
            class="mb-12"
          >
            <base-img
              max-width="100%"
              src="https://cdn.vuetifyjs.com/store/themes/zero/pro.png"
            />
          </v-card>

          <div class="text-center">
            <base-btn
              :tile="false"
              color="primary"
              href="https://store.vuetifyjs.com/product/zero-theme-pro/?ref=vtyd-pro-page-features"
              rounded
            >
              Buy Pro Now

              <v-icon right>
                mdi-rocket
              </v-icon>
            </base-btn>
          </div>
        </v-col>
      </v-row> -->
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionProChart',

    data: () => ({

    }),
  }
</script>
